(function() {
    var Accordion = {
        accordionElement : null,
        accordionTriggerElements : [],
        accordionOptionElements : {},
        accordionOptionTargetElements : {},

        accordionActiveClass : "open",
        activeTriggerId : null,
        
        activateAccordionOption : function(triggerId) {
            if ( this.activeTriggerId != null ) {
                this.accordionOptionElements[this.activeTriggerId].target.style.maxHeight = "";
                this.accordionOptionElements[this.activeTriggerId].target.classList.remove(this.accordionActiveClass);
            }
            this.activeTriggerId = triggerId;
            var height = this.accordionOptionElements[this.activeTriggerId].height + "px";
            this.accordionOptionElements[this.activeTriggerId].target.style.maxHeight = height;
            this.accordionOptionElements[this.activeTriggerId].target.classList.add(this.accordionActiveClass);
        },

        addEventListeners : function() {
            for ( var i = 0; i < this.accordionTriggerElements.length; i++ ) {
                var currentTriggerElement = this.accordionTriggerElements[i];
                currentTriggerElement.addEventListener('click', function(e) {
                    var triggerId = e.currentTarget.getAttribute('accordion-trigger');
                    this.activateAccordionOption(triggerId);
                }.bind(this));
            }
        },

        init : function(accordionElement) {
            this.accordionElement = accordionElement;
            this.accordionTriggerElements = this.accordionElement.querySelectorAll('[accordion-trigger]');
            var accordionOptionElements = this.accordionElement.querySelectorAll('[accordion-option]');
            for ( var i = 0; i < accordionOptionElements.length; i++ ) {
                var currentAccordionOptionElement = accordionOptionElements[i];
                var optionId = currentAccordionOptionElement.getAttribute('accordion-option');
                var targetSelector = '[accordion-option-target="' + optionId + '"]';
                var target = this.accordionElement.querySelector(targetSelector);
                this.accordionOptionElements[optionId] = {
                    element : currentAccordionOptionElement,
                    height : currentAccordionOptionElement.offsetHeight + 25,
                    target : target
                };
            }

            this.addEventListeners();
        }
    }

    var AccordionConfig = {
        accordions : [],

        init : function() {
            var accordionElements = document.querySelectorAll('[accordion]');
            for ( var i = 0; i < accordionElements.length; i++ ) {
                var currentAccordionElement = accordionElements[i];
                var currentAccordion = Object.assign({}, Accordion);
                currentAccordion.init(currentAccordionElement);
                this.accordions.push(currentAccordion);
            }
        }
    }

    window.wghi.AccordionConfig = AccordionConfig;

    document.addEventListener('DOMContentLoaded', function(e) {
        window.wghi.AccordionConfig.init();
    });
})();